module.exports = __webpack_public_path__ + "img/03.adb2d190.png";